<template>
    <div class="wrapper">
        <div class="columns investment-content is-desktop">
            <div class="column is-12-mobile is-9-tablet">
                <div class="mb-4">
                    <span @click="$store.commit('compare/SET_TYPE_BACK_BTN', true), $router.go(-1)" class="btn btn-clear">Back</span>
                </div>
                <div class="is-flex is-align-items-center">
                    <h1 class="is-size-5 is-size-4-desktop has-text-weight-bold mr-5">{{ this.listing.shareclass[0] ? this.listing.shareclass[0].query.FundBasicsName + ' - ': 'Investment Platforms' }}<span v-show="this.listing.shareclass[0]" class="color-grey">Investment Platforms</span></h1>
                    <div class="is-hidden-mobile"><page-help :height="'480px'" :pageHelp="'referral'"/></div>
                    <a href="/pages/choosing-the-best-investment-platform" class="is-hidden-mobile button is-uppercase ml-5 is-size-7 is-primary bg-green" style="height: 40px;" target="_blank"><span>Platform Guide</span></a>
                </div>
                <h3 class="has-text-weight-400 m-b-20 m-t-20-mobile">Check on which platforms you can buy your fund share classes</h3>
                <div class="is-flex is-align-item-center is-flex-wrap-wrap wrapper-box-platform m-b-20">
                    <div class="box-platform" v-for="(item) in this.listPlatforms" :key="item.platform">
                        {{ item.platform_name ? item.platform_name : item.platform}} <span>|</span> {{item.platform }}
                    </div>
                </div>
                <div class="is-flex is-justify-content-center is-align-items-center is-hidden-tablet m-b-20">
                    <p class="has-text-center is-size-7-mobile grey-text-2"><img src="/img/h-scroll.svg" class="h-scroll-icon"> Swipe table to see more</p>
                </div>
                <div class="wrapper-referral">
                    <b-tooltip v-if="isActive && listing.shareclass.length>1" class="compare-to-peers-tooltip referral-tooltip" label="Select platform to view only share classes available there" always></b-tooltip>
                    <tabs :showall="isShowAllPlatform" class="referral-page" :mode="mode" :currentTab="currentTab" @isShowAllPlatform="isShowAllPlatform=!isShowAllPlatform">
                        <div class="scroll-table-wrapper only-horizontal-scroll scroll-table-mobile m-b-20-tablet">
                            <tab class="active" title="Highlights">
                                <table class="referral-table-1">
                                    <thead>
                                    <tr>
                                        <td>
                                            <div class="text-align-left" v-if="listing.platforms.length>0">
                                                <b-dropdown class="dropdown-platform" :append-to-body="true" :mobile-modal="false" aria-role="list" v-model="platformActive">
                                                    <template #trigger="{ active }">
                                                        <div class="is-flex is-align-items-center height-18" role="button">
                                                            <span class="inline-block is-size-7">Where to trade</span>
                                                            <b-icon pack="mdi" class="ml-1 mt-1 is-relative" :icon="active?'menu-up':'menu-down'">
                                                            </b-icon>
                                                        </div>
                                                    </template>
                                                    <div>
                                                        <b-dropdown-item :value="''" aria-role="listitem">All</b-dropdown-item>
                                                    </div>
                                                    <template v-for="(item, n) in listing.platforms" >
                                                        <div :key="item+n">
                                                            <b-dropdown-item :value="item" aria-role="listitem">{{item}}</b-dropdown-item>
                                                        </div>
                                                        
                                                    </template>
                                                </b-dropdown>
                                            </div>
                                            <div v-else>Where to trade</div>
                                        </td>
                                        <td></td>
                                        <td>Unit
                                            <button v-tooltip="{content: 'Type of Unit, Income or Accumulation', trigger: 'hover click'}">?</button>
                                        </td>
                                        <td>Price CCY</td>
                                        <td class="pr-0" style="text-align: right!important;">CCY Hedged</td>
                                        <td class="pl-0" style="text-align: left!important;"><span class="sep"></span>To
                                        </td>
                                        <td>Net Assets
                                            <button v-tooltip="{content: 'Share Class Net Assets', trigger: 'hover click'}">?</button>
                                        </td>
                                        <td>OGC
                                            <button v-tooltip="{content: 'Ongoing Charge', trigger: 'hover click'}">?</button>
                                        </td>
                                        <td></td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="(i, index) in listing.shareclass">
                                        <tr v-bind:class="(index == 0)?'wh':''" :key="index" v-show="isShowAllPlatform || i.shareclass_referral.length>0">

                                            <td v-bind:class="(index == 0)?'full-column':'full-column'" colspan="9">
                                                <div><span class="link has-text-underline" v-on:click="search(isisin(i.query.ISIN))">{{ i.query.ShareClassBasicsName }}</span> </div>
                                                <div>ISIN: {{ isisin(i.query.ISIN)}}</div>
                                            </td>
                                        </tr>
                                        <tr v-bind:class="(index == 0)?'wh':''" :key="index" v-show="isShowAllPlatform || i.shareclass_referral.length>0">
                                            <td class="p-r-0" v-if="i.shareclass_referral.length">
                                                <div class="sharpe-box-platform" :class="i.shareclass_referral.length<=3?'platform-under-three':''">
                                                    <template v-for="(r, ind) in i.shareclass_referral">
                                                        <span class="platform vertical-align-middle" :key="ind" v-if="ind<3">
                                                            <span v-if="r.platform">
                                                                <a @click="ga(i.query.ShareClassBasicsName, r.webaddress, r.platform, i.query.ISIN)"><span>{{
                                                                        r.platform
                                                                    }}</span> &nbsp;</a>
                                                            </span>
                                                        </span>
                                                    </template>
                                                </div>
                                            </td>
                                            <td class="p-r-0" v-else>
                                                <div class="sharpe-box-platform" :class="i.shareclass_referral.length<3?'platform-under-three':''"><span class="vertical-align-middle not-available">n/a</span></div>
                                            </td>
                                            <td class="p-l-0" v-if="i.shareclass_referral.length > 3 ">
                                                <div class="sharpe-box-other is-hidden-mobile">
                                                <b-dropdown aria-role="list" class="dropdown-other" :mobile-modal="false">
                                                    <button class="button" slot="trigger"
                                                            slot-scope="{ active }"
                                                            >
                                                                <span class="other-text">Other</span>
                                                                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                    </button>
                                                    <template v-for="(r, ind) in i.shareclass_referral">
                                                        <b-dropdown-item :href="r.webaddress" target="_new" aria-role="listitem"
                                                            :key="ind" v-if="ind >= 3">
                                                                <div @click="saveDataPlatform(i.query.ISIN, r.platform)"> {{ r.platform }}</div>
                                                        </b-dropdown-item>
                                                    </template>
                                                </b-dropdown>
                                                </div>
                                                <div class="sharpe-box-other is-hidden-tablet">
                                                <b-dropdown aria-role="list" class="dropdown-other" :append-to-body="listing.shareclass.length<4?true:false" :mobile-modal="false">
                                                    <button class="button" slot="trigger"
                                                            slot-scope="{ active }"
                                                            >
                                                                <span class="other-text">Other</span>
                                                                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                    </button>
                                                    <template v-for="(r, ind) in i.shareclass_referral">
                                                        <b-dropdown-item :href="r.webaddress" target="_new" aria-role="listitem"
                                                            :key="ind" v-if="ind >= 3">
                                                                <div @click="saveDataPlatform(i.query.ISIN, r.platform)"> {{ r.platform }}</div>
                                                        </b-dropdown-item>
                                                    </template>
                                                </b-dropdown>
                                                </div>
                                            </td>
                                            <td v-else>
                                            </td>
                                            <td>
                                                <span v-if="i.query.IncomeDistribution && i.query.AccumulatedDistribution">INC & ACC</span>
                                                <span v-else-if="i.query.IncomeDistribution" class="label inc-acc-referral" style="background-color: #AFEF97; color: #363636;">INC</span>
                                                <span v-else-if="i.query.AccumulatedDistribution" class="label active inc-acc-referral" >ACC</span>

                                            </td>

                                            <td><span>{{ i.query.CurrencyId }}</span></td>
                                            <td class="pr-0" style="text-align: right !important;" align="right"><span
                                                v-if="i.query.CurrencyHedged">Yes</span>
                                                <span v-else>No</span></td>
                                            <td class="pl-0" style="text-align: left !important;" align="left"><span
                                                class="sep"></span><span>{{ i.query.CurrencyHedgedToId }}</span></td>
                                            <!--<td><span>{{ currency("GBP", parseNA(i.query.LatestNetAssetValue)) }}</span></td>-->
                                            <td><span>£{{ numbersformat(i.query.sc_netassets_gbp) }}</span></td>

                                            <td>
                                                <span v-if="i.query.ongoingchargecomp">{{ i.query.ongoingchargecomp }}%</span>
                                                <span v-else class="not-available">n/a</span>
                                            </td>
                                            <td class="p-b-20">
                                                <buttons :ISIN="i.query.ISIN" :isHidden="true" :fund_data="i.query"></buttons>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </tab>
                            <tab title="Returns & Charges">
                                    <table class="referral-table-1">
                                        <thead>
                                        <tr>
                                            <td>
                                                <div class="text-align-left" v-if="listing.platforms.length>0">
                                                    <b-dropdown class="dropdown-platform" :append-to-body="true" :mobile-modal="false" aria-role="list" v-model="platformActive">
                                                        <template #trigger="{ active }">
                                                            <div class="is-flex is-align-items-center height-18" role="button">
                                                                <span class="inline-block is-size-7">Where to trade</span>
                                                                <b-icon pack="mdi" class="ml-1 mt-1" :icon="active?'menu-up':'menu-down'"></b-icon>
                                                            </div>
                                                        </template>
                                                        <b-dropdown-item :value="''" aria-role="listitem">All</b-dropdown-item>
                                                        <template v-for="(item, n) in listing.platforms" >
                                                            <div :key="item+n">
                                                                <b-dropdown-item :value="item" aria-role="listitem">{{item}}</b-dropdown-item>
                                                            </div>
                                                            
                                                        </template>
                                                    
                                                    </b-dropdown>
                                                </div>
                                                <div v-else>Where to trade</div>
                                            </td>
                                            <td></td>
                                            <td>Price CCY</td>
                                            <td>OGC
                                                <button v-tooltip="{content: 'Ongoing Charge', trigger: 'hover click'}">?</button>
                                            </td>
                                            <td>NTR 1Y
                                                <button v-tooltip="{content: 'Annualised Net Total Return 1 Year', trigger: 'hover click'}">?</button>
                                            </td>
                                            <td>NTR 3Y
                                                <button v-tooltip="{content: 'Annualised Net Total Return 3 Year', trigger: 'hover click'}">?</button>
                                            </td>
                                            <td>NTR 5Y
                                                <button v-tooltip="{content: 'Annualised Net Total Return 5 Year', trigger: 'hover click'}">?</button>
                                            </td>
                                            <td>Yield
                                                <button v-tooltip="{content: '12m Yield', trigger: 'hover click'}">?</button>
                                            </td>
                                            <td></td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-for="(i, index) in listing.shareclass">
                                            <tr :key="index" v-show="isShowAllPlatform || i.shareclass_referral.length>0">
                                                <td v-if="index == 0" colspan="9" class="full-column">
                                                    <div><span class="link has-text-underline" v-on:click="search(isisin(i.query.ISIN))">{{ i.query.ShareClassBasicsName }}</span> </div>
                                                    <div>ISIN: {{ isisin(i.query.ISIN)}}</div>
                                                </td>
                                                <td v-else colspan="9" class="full-column">
                                                    <div><span class="link has-text-underline" v-on:click="search(isisin(i.query.ISIN))">{{ i.query.ShareClassBasicsName }}</span> </div>
                                                    <div>ISIN: {{ isisin(i.query.ISIN)}}</div>
                                                </td>
                                            </tr>
                                            <tr v-bind:class="(index == 0)?'wh':'wh'" :key="index" v-show="isShowAllPlatform || i.shareclass_referral.length>0">
                                                <td class="p-r-0" v-if="i.shareclass_referral.length">
                                                    <div class="sharpe-box-platform" :class="i.shareclass_referral.length<=3?'platform-under-three':''">
                                                        <template v-for="(r, ind) in i.shareclass_referral">
                                                            <span class="platform vertical-align-middle" :key="ind" v-if="ind <3">
                                                                <span v-if="r.platform">
                                                                    <a @click="ga(i.query.ShareClassBasicsName, r.webaddress, r.platform, i.query.ISIN)"><span>{{ r.platform }}</span> &nbsp;</a>
                                                                </span>
                                                            </span>
                                                        </template>
                                                    </div>
                                                </td>
                                                <td class="p-r-0" v-else>
                                                    <div class="sharpe-box-platform" :class="i.shareclass_referral.length<=3?'platform-under-three':''"><span class="vertical-align-middle not-available">n/a</span></div></td>
                                                <td class="p-l-0" v-if="i.shareclass_referral.length > 3 ">
                                                    <div class="p-l-0 sharpe-box-other is-hidden-mobile">
                                                        <b-dropdown aria-role="list" class="dropdown-other" :mobile-modal="false">
                                                            <button class="button" slot="trigger"
                                                                    slot-scope="{ active }">
                                                                <span>Other</span>
                                                                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                            </button>
                                                            <template v-for="(r, ind) in i.shareclass_referral">
                                                                <b-dropdown-item :href="r.webaddress" target="_new" aria-role="listitem"
                                                                        :key="ind" v-if="ind>=3">
                                                                    <div @click="saveDataPlatform(i.query.ISIN,r.platform)">{{ r.platform }}</div> 
                                                                </b-dropdown-item>
                                                            </template>
                                                        </b-dropdown>
                                                    </div>
                                                    <div class="p-l-0 sharpe-box-other is-hidden-tablet">
                                                        <b-dropdown aria-role="list" class="dropdown-other" :append-to-body="listing.shareclass.length<4?true:false" :mobile-modal="false">
                                                            <button class="button" slot="trigger"
                                                                    slot-scope="{ active }">
                                                                <span>Other</span>
                                                                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                                            </button>
                                                            <template v-for="(r, ind) in i.shareclass_referral">
                                                                <b-dropdown-item :href="r.webaddress" target="_new" aria-role="listitem"
                                                                        :key="ind" v-if="ind>=3">
                                                                    <div @click="saveDataPlatform(i.query.ISIN,r.platform)">{{ r.platform }}</div> 
                                                                </b-dropdown-item>
                                                            </template>
                                                        </b-dropdown>
                                                    </div>
                                                </td>
                                                <td v-else>
                                                </td>

                                                <td><span v-bind:class="(i.query.CurrencyId < 0)?'red':''">{{
                                                        i.query.CurrencyId
                                                    }}</span></td>
                                                <td>
                                                    <span v-if="i.query.ongoingchargecomp" v-bind:class="(i.query.ongoingchargecomp < 0)?'red':''">{{i.query.ongoingchargecomp}}%</span>
                                                    <span v-else class="not-available">n/a</span>
                                                </td>

                                                <td v-if="!isNaN(parseFloat(i.query.CumulativeTotalReturn1Year) )"><span
                                                    v-bind:class="(i.query.CumulativeTotalReturn1Year < 0)?'red':''">{{
                                                        parseFloat(i.query.CumulativeTotalReturn1Year).toFixed(2)
                                                    }}%</span></td>
                                                <td v-else><span class="not-available">n/a</span></td>
                                                <td v-if="!isNaN(parseFloat(i.query.TotalReturn3Years) )"><span
                                                    v-bind:class="(i.query.TotalReturn3Years < 0)?'red':''">{{
                                                        parseFloat(i.query.TotalReturn3Years).toFixed(2)
                                                    }}%</span></td>
                                                <td v-else><span class="not-available">n/a</span></td>
                                                <td v-if="!isNaN(parseFloat(i.query.TotalReturn5Years) )"><span
                                                    v-bind:class="(i.query.TotalReturn5Years < 0)?'red':''">{{
                                                        parseFloat(i.query.TotalReturn5Years).toFixed(2)
                                                    }}%</span></td>
                                                <td v-else><span class="not-available">n/a</span></td>
                                                <td v-if="!isNaN(parseFloat(i.query.yield12m) )"><span
                                                    v-bind:class="(i.query.yield12m < 0)?'red':''">{{
                                                        parseFloat(i.query.yield12m).toFixed(2)
                                                    }}%</span></td>
                                                <td v-else><span class="not-available">n/a</span></td>
                                                <td class="p-b-20">
                                                    <buttons :ISIN="i.query.ISIN" :isHidden="true" :fund_data="i.query"></buttons>
                                                </td>
                                            </tr>

                                        </template>
                                    </tbody>
                                </table>

                            </tab>
                        </div>
                    </tabs>
                </div>
                <div class="columns is-mobile simple-markdown">
                    <div class="column is-12-tablet pl-5 pr-5 disclaimer">
                    <vue-simple-markdown :source="snippet"/>
                    </div>
                </div>

            </div>

            <div ref="subRight_before" class="column is-12-mobile is-3-tablet">
                <div class="">
                    <div class="banner-on-top" ref="subRight">
                        <AdsGoogle />
                    </div>
                </div>
            </div>

        </div>




</div>


</template>

<style scoped>
::v-deep .mdi-24px.mdi:before {
    color: #363636;
}
.dropdown .dropdown-trigger .button:hover ::v-deep .mdi-24px.mdi:before{
    color: #fff;
}
table.referral-table-1 tbody tr td, table.comparison-table-3 tbody tr td {
    padding-bottom: 0;
}

.dark span, .dark {
    background-color: #595959;
    color: #fff;
}

.dark button span {
    background-color: #FFF;
    color: #000;
}

.full-column span {
    font-size: 16px;
    font-weight: bold;
}

.ads {
    background-color: #355160;
    color: #FFF;

    width: 100%;
    min-height: 100%;
    display: inline-block;
}

.tab {
    width: 100%
}

.platform::after {
    content: "|";
    margin-right: 3px;
    display: inline-block;
}

.platform:last-child::after {
    content: "";
    display: inline-block;
}

.investment-content {
    min-height: 800px;
}
.wrapper-referral {
    position: relative;
}
span.compare-to-peers-tooltip.b-tooltip.referral-tooltip {
    left: 107px;
    top: 54px;
    z-index: 60;
    text-align: center;
}
.link {
    color: #009BDE;
    cursor: pointer;
}
.box-platform {
    background-color: #000093;
    color: #fff;
    padding: 0.25rem;
    border-radius: 5px;
    font-size: 0.85em;
    max-width: 180px;
    gap: 4px;
    text-align: center;
    display: flex;
    align-items: center;
    min-height: 49px;
    margin-bottom: 4px;
    overflow: hidden;
}
.box-platform span {
    color: #fff;
    font-size: 25px; 
}
.wrapper-box-platform {
    gap: 0.5rem;
}
@media (max-width: 767px) {
    .box-platform {
        max-width: 48%;
        width: 48%;
        justify-content: center;
    }
}
</style>

<script>
import commonMixin from "@/mixins/commonMixin";
import bannerMixin from "@/mixins/bannerMixin";
import axios from "axios";
import Tab from '../components/tab.vue';
import Tabs from '../components/tabs.vue'
import Buttons from "@/components/Buttons";
import PageHelp from '@/components/PageHelp.vue';
import AdsGoogle from '@/components/AdsGoogle.vue';

export default {
    name: 'Referral',

    props: {},
    mixins: [commonMixin, bannerMixin],
    data() {
        return {
            snippet: "",
            listing: {
                platforms: [],
                shareclass: []
            },
            listPlatforms: [],
            radioButton: '',
            years_existence: [0.3, 21.5],
            manager_tenure: [0.5, 15.5],
            number_holdings: [15, 80],
            max_ongoing: [0.2, 6],
            return_year: [-30.1, 14],
            return_year_1: [-29.5, 4.3],
            return_year_3: [-12.9, 12.2],
            return_year_5: [-3.6, 13.3],
            net_assets: [25, 10001],
            quoted_yield: [0.25, 6],
            max_3y: [1, 15.7],
            radio1: 'Yes',
            radio2: 'Yes',
            radio3: 'Yes',
            radio4: 'Yes',
            radio5: 'Yes',
            radio6: 'All',
            mode: 'dark',
            currentTab: this.$store.state.search.currentTab,
            isShowAllPlatform: true,
            platformActive: '',
            isActive: true,
        }
    },

    watch: {
        platformActive: function(value) {
            this.getdata(value)
        },
        snippet: function() {
            this.handleScroll()
        }
    },

    methods: {
        windowScroll() {
            if (window.scrollY) {
                if (window.innerWidth < 768) {
                    var self = this;
                    setTimeout(function(){
                        self.isActive=false;    
                    },5000)
                } else {
                    this.isActive=false;
                } 
            }
            this.handleScroll()
        },
        async getdata(platform) {
            await axios
                .get('/search/shareclasses/' + this.$route.params.id,
                {
                    params: {
                        platform: platform
                    }
                })
                .then(response => {
                    this.listing = response.data
                    this.listing.shareclass.forEach(e => {
                        e.shareclass_referral.forEach( f => {
                            let platform = f.platform;
                            let platform_name = f.platform_name;
                            let found = this.listPlatforms.some(el => el.platform === platform);
                            if (!found) this.listPlatforms.push({platform, platform_name});
                        })
                    });
                    this.listPlatforms = this.listPlatforms.sort((a, b) => {
                        if ( a.platform < b.platform ){
                            return -1;
                        }
                        if ( a.platform > b.platform ){
                            return 1;
                        }
                        return 0;
                    });
                })
                .catch((error) => alert(error))
        },
        numbersformat(labelValue) {


            // Nine Zeroes for Billions
            return Math.abs(Number(labelValue)) >= 1.0e+9

                ? parseFloat(Math.abs(Number(labelValue)) / 1.0e+9).toFixed(2) + "b"
                // Six Zeroes for Millions
                : parseFloat(Math.abs(Number(labelValue)) >= 1.0e+6).toFixed(2)

                    ? parseFloat(Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + "m"
                    // Three Zeroes for Thousands
                    : parseFloat(Math.abs(Number(labelValue)) >= 1.0e+3).toFixed(2)

                        ? parseFloat(Math.abs(Number(labelValue)) / 1.0e+3).toFixed(2) + "k"

                        : parseFloat(Math.abs(Number(labelValue))).toFixed(2);


        },
        ga(name, address, platform,ISIN){
            this.saveDataPlatform(ISIN, platform);
            if (address) {
                window.open(address, "_blank");
            }
            this.$gtag.event("referral_paf", {
                'event_category': address,
                'event_label': name,
            })
        },
        saveDataPlatform(ISIN, platform) {
            axios.get(`/search/saveplatform/${ISIN}?platform=${platform}`)
        },
        async search(isin){
            var searchObject = {
                type: 'isin',
                text: isin,
                code: isin,
                source: 1,
            }
           await this.$store.dispatch("search/apiCall",{...searchObject, keyword: isin})
           const textURL = this.convertURL(searchObject.text.replaceAll('/', '*'))
           this.$store.commit("search/SET_VALUE_SEARCH_BAR", isin)
           this.$store.commit("search/SET_NEW_SEARCH_SECTION", true)
           await this.$router.push({name:"Results", params: {
                id: this.$store.state.search.searchData.searchdata_id,
                text: textURL!==''?textURL:'All'}})
       },
    },
    async mounted() {

        await this.getdata(undefined);

        axios.get("/api/article/5").then(response => {
            this.snippet = response.data[0].description
        })

        axios.get('/search/saveinvdata',
        {
            params: {
                source: this.$store.state.compare.typeCompareDetail,
                native: this.$store.state.search.currency,
                ISIN: this.listing.shareclass[0].query.ISIN,
            }
        })

        this.$store.commit('compare/SET_TYPE_COMPARE_DETAIL', 'referral_page');
    },
    components: {
        Tab,
        Tabs, 
        Buttons,
        PageHelp,
        AdsGoogle
    },
    metaInfo() {
        return {
            title: `${this.listing.shareclass[0]?this.listing.shareclass[0].query.FundBasicsName + ' - ':''}Investment Platforms | Pickafund`,
            meta: [
                { name: 'description', content:  'Find a platform on which to invest in your chosen fund'},
                { property: 'og:title', content: `${this.listing.shareclass[0]?this.listing.shareclass[0].query.FundBasicsName:''} - Investment Platforms | Pickafund`},
            ]
        }
    },
    created() {
        var self = this;
        setTimeout(function(){
            window.addEventListener('scroll', self.windowScroll);
        }, 1000)
        
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.windowScroll);
    },
}
</script>
